import React from 'react';
import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';


import Attributions from './routes/Attributions'
import Collaborations from './routes/Collaborations';
import Contribution from './routes/Contribution';
import Description from './routes/Description';
import Education from './routes/Education';
import Engineering from './routes/Engineering';
import Experiments from './routes/Experiments';
import Home from './routes/Home';
import IHP from './routes/IHP';
import Implementation from './routes/Implementation';
import Members from './routes/Members';
import Model from './routes/Model';
import Notebook from './routes/Notebook';
import Results from './routes/Results';
import Sponsors from './routes/Sponsors';




function App(){
  console.log(process.env.PUBLIC_URL);
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes basename={process.env.PUBLIC_URL}>
          <Route path='/' element={<Home/>}/>
          <Route path='/description' element={<Description/>}/>
          <Route path='/implementation' element={<Implementation/>}/>
          <Route path='/contribution' element={<Contribution/>}/>
          <Route path='/human-practices' element={<IHP/>}/>
          <Route path='/education' element={<Education/>}/>
          <Route path='/attributions' element={<Attributions/>}/>
          <Route path='/collaborations' element={<Collaborations/>}/>
          <Route path='/engineering' element={<Engineering/>}/>
          <Route path='/members' element={<Members/>}/>
          <Route path='/model' element={<Model/>}/>
          <Route path='/notebook' element={<Notebook/>}/>
          <Route path='/results' element={<Results/>}/>
          <Route path='/sponsors' element={<Sponsors/>}/>
          <Route path='/experiments' element={<Experiments/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
